
interface EnvType {
    REACT_APP_BASE_API: string;
}

const env = process.env as unknown as EnvType;
const baseUrlApi = env.REACT_APP_BASE_API;

export default baseUrlApi;